import { Pipe, PipeTransform, inject } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({ name: 'unixDateFormatter' })
export class UnixDateFormatterPipe implements PipeTransform {
  private datePipe = inject(DatePipe);

  transform(value: number | null, format: string = 'MMM d, yyyy'): string {
    if (!value === null) {
      return '';
    }

    const date = new Date(value * 1000);
    return this.datePipe.transform(date, format) || '';
  }
}
